<template>
  <div>
    <h3>站点全局设置</h3>
    <el-card style="margin-top:20px;max-width:600px">
      <el-form :model="form" label-width="160px">
        <el-form-item label="教练列表展示模式">
          <el-radio-group v-model="form.coachViewMode">
            <el-radio label="single">单列</el-radio>
            <el-radio label="double">双列</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="帖子列表展示模式">
          <el-radio-group v-model="form.postViewMode">
            <el-radio label="single">单列</el-radio>
            <el-radio label="double">双列</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="是否开启评论">
          <el-switch v-model="form.enableComment"></el-switch>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="saveConfig">保存设置</el-button>
        </el-form-item>
      </el-form>
    </el-card>
  </div>
</template>

<script>
import { getSiteConfig, saveSiteConfig } from "../api";
export default {
  data() {
    return {
      form: {
        coachViewMode: "single",
        postViewMode: "single",
        enableComment: true
      }
    };
  },
  mounted() {
    this.loadConfig();
  },
  methods: {
    async loadConfig() {
      const res = await getSiteConfig();
      this.form = res.data;
    },
    async saveConfig() {
      await saveSiteConfig(this.form);
      this.$message.success("保存成功");
    }
  }
};
</script>
